<form [formGroup]="consultationHistoryForm">
    <div class="card-container mat-elevation-z1">
        <div class="card-content">
            <div>
                <div *ngIf="medicalAppointmentId" class="card-box-medium margin-right-small">
                    <mat-spinner *ngIf="loadingEditInfo"></mat-spinner>
                    <div *ngIf="!loadingEditInfo" class="margin-top-medium full-width">
                        <h5 class="card-inline">Protocolo: <b>{{protocol}}</b></h5>
                        <div class="card-inline margin-left-medium">
                            <h5> Paciente: <b>{{patientFullName}}</b></h5>
                        </div>
                        <div class="card-inline margin-left-medium">
                            <h5> Edad: <b>{{patientAge}}</b></h5>
                        </div>
                    </div>

                    <div *ngIf="!loadingEditInfo" class="margin-top-medium margin-botton-small">
                        <table class="full-width" mat-table [dataSource]="dataSourcePrincipal">
                            <tr mat-header-row class="table-header" *matHeaderRowDef="displayColumnsPrincipal"></tr>
                            <tr class="table-cell" mat-row *matRowDef="let row; let i = index; columns: displayColumnsPrincipal;"></tr>
                            <ng-container matColumnDef="PracticeRegionName">
                                <th mat-header-cell class="table-header" *matHeaderCellDef> Práctica </th>
                                <td mat-cell class="table-cell" *matCellDef="let element"> {{element.PracticeRegionName}} </td>
                            </ng-container>
                            <ng-container matColumnDef="Quantity">
                                <th mat-header-cell class="table-header" *matHeaderCellDef> Cantidad </th>
                                <td mat-cell class="table-cell" *matCellDef="let element"> {{element.Quantity}} </td>
                            </ng-container>
                        </table>
                    </div>
                    <angular-editor *ngIf="!loadingEditInfo" id="editorHistoriaClinicaObservacion" placeholder="Estado actual" formControlName="MedicalConsultationObservation" [config]="editorConfig"></angular-editor>
                    <table style="width: 100%;">
                        <tr>
                            <td>
                                <mat-form-field *ngIf="!loadingEditInfo" class="full-width margin-top-small">
                                    <textarea class="texto-medication" matInput placeholder="Medicación actual" formControlName="MedicalConsultationMedication"></textarea>
                                </mat-form-field>
                            </td>
                            <td *ngIf="canCreatePrescriptions" style="width: 30px;">
                                <img (click)="editPrescription()" class="download-prescription" src="../../../../Content/Images/addchart-24px.svg">
                            </td>
                        </tr>

                    </table>
                </div>
                <div [ngClass]="{ 'card-box-medium': medicalAppointmentId != null , 'full-width':  medicalAppointmentId == null }">
                    <h4 *ngIf="medicalAppointmentId">Prácticas anteriores</h4>
                    <mat-divider></mat-divider>
                    <div class="full-width">
                        <mat-form-field class="medium-width inline">
                            <input type="text" formControlName="Physician" (input)="onPhysicianChange()" #physiciansControl matInput placeholder="Médico" [matAutocomplete]="autPhysician">
                            <mat-autocomplete #autPhysician="matAutocomplete" (optionSelected)="physicianSelected($event.option.value)" [displayWith]="filterCompletePhysicians.displayFn">
                                <mat-option *ngFor="let physician of filteredPhysiciansOptions | async" [value]="physician">
                                    {{physician.Name}}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                        <mat-form-field class="medium-width inline">
                            <input type="text" #specialityControl (input)="onSpecialityChange()" formControlName="Speciality" matInput placeholder="Especialidad" [matAutocomplete]="autSpeciality">
                            <mat-autocomplete #autSpeciality="matAutocomplete" (optionSelected)="specialitySelected($event.option.value)" [displayWith]="filterCompleteSpecialities.displayFn">
                                <mat-option *ngFor="let speciality of filteredSpecialitiesOptions | async" [value]="speciality">
                                    {{speciality.Name}}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                        <mat-spinner *ngIf="loading" [diameter]="20"></mat-spinner>
                        <div style="max-height: 420px" class="medical-consultation-history" *ngIf="!loading">
                            <div *ngFor="let medicalConsultationHistory of medicalConsultationHistoriesFiltered()">
                                <table style="width: 100%;">
                                    <tr>
                                        <td>
                                            <div>
                                                <div><b><b> {{ medicalConsultationHistory.PhysicianFullName }} {{ medicalConsultationHistory.Date | date: 'dd/MM/yyyy' }} </b></b>
                                                </div>
                                                <div> {{ medicalConsultationHistory.PracticeRegionName }}</div>
                                                <div> {{ medicalConsultationHistory.Medicament }} </div>
                                                <div class="text-observation-history margin-botton-medium" [innerHTML]="medicalConsultationHistory.Observation"></div>
                                            </div>
                                        </td>
                                        <td>
                                            <mat-spinner *ngIf="medicalConsultationHistory.downloadingPrescription" [diameter]="30"></mat-spinner>
                                            <img *ngIf="medicalConsultationHistory.HasPrescription && !medicalConsultationHistory.downloadingPrescription" (click)="downloadPrescriptions(medicalConsultationHistory)" class="download-prescription" src="../../../../Content/Images/article-24px.svg">
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>